import React from "react";
import { Link } from "gatsby";
import { DropDown, DropDownList, DropDownListItem } from "./dropdown";

function Resources({ isActive }) {  
	return(
		<DropDown className={`dropdown-menu dropdown-menu-right ${isActive ? "active" : ""}`}>
			<DropDownList>
				<DropDownListItem><Link to="/about-us">About Us</Link></DropDownListItem>				
				<DropDownListItem><Link to="/easy-payment-options">Easy Payment Options</Link></DropDownListItem>				
				<DropDownListItem><Link to="/financing">Financing</Link></DropDownListItem>				
				<DropDownListItem><Link to="/rto">Rent To Own</Link></DropDownListItem>				
				<DropDownListItem><Link to="/help-and-info">Help and Info</Link></DropDownListItem>				
				<DropDownListItem><Link to="/service-area">Service Area</Link></DropDownListItem>				
				<DropDownListItem><Link to="/faq">FAQ's</Link></DropDownListItem>				
				<DropDownListItem><Link to="/gallery">Gallery</Link></DropDownListItem>				
				<DropDownListItem><Link to="/blog">Blogs</Link></DropDownListItem>				
				<DropDownListItem><Link to="/reviews">Reviews</Link></DropDownListItem>				
				<DropDownListItem><Link to="/contact">Contact Us</Link></DropDownListItem>				
			</DropDownList>
		</DropDown>
	)
};

export default Resources;